import api from '../../services/api';

async function getDjUrl() {
  const response = await api<string>('GET', 'ddjj/link');

  return response;
}

const declaracionAPI = {
  getDjUrl,
};

export default declaracionAPI;
